module.exports = __webpack_public_path__ + "692b2ac094cb0b2679dadd8cba568087.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Lato-Regular.woff
// module id = 1482
// module chunks = 0